var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconNavigationFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.595.281a.807.807 0 00-.25.054L.762 9.205a.807.807 0 00.127 1.541l10.78 2.31 2.309 10.78a.807.807 0 001.54.125l8.871-22.58a.807.807 0 00-.795-1.1z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}

export default SvgCommonIconNavigationFilled;